import React from "react";
// eslint-disable-next-line import/order
import ReactDOM from "react-dom";

import "./css/component.scss";
import "./css/reset.scss";
import "./css/layout.scss";
import { Provider } from "react-redux";
import { Router } from "react-router-dom";

import App from "./components/App";
import initFontIcon from "./core/init.font.icon";
import { history } from "./history";
import store from "./store";
import configs from "@/configs";
import { UserProfileContextProvider } from "./context/UserProfileContext";

if (
  (configs.REACT_APP_ENV === "development" &&
    window.navigator.maxTouchPoints >= 1) ||
  localStorage.getItem("@HUNGER/MERCHANT/DEBUG") === "true"
) {
  (async () => {
    const VConsole = await require("vconsole");
    new VConsole();
  })();
}

initFontIcon();

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router history={history}>
        <UserProfileContextProvider>
          <App />
        </UserProfileContextProvider>
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
